import { TooltipContainer } from '@tkww/orion-web-ds';
import { Tooltip } from '@tkww/orion-web-ds-feedback';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import classNames from 'classnames';
import React, { useState } from 'react';
import Styles from './styles.scss';

interface LocalAverageTooltipProps {
	variant?: 'costBreakdown' | 'editEstimateForm';
}

export const LocalAverageTooltip = ({
	variant = 'costBreakdown',
}: LocalAverageTooltipProps) => {
	const [showTooltip, setShowTooltip] = useState(false);

	return (
		<TooltipContainer className={Styles.localAverageContainer}>
			<button
				type="button"
				className={Styles.localAverageTrigger}
				aria-label="Local average information"
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
				onFocus={() => setShowTooltip(true)}
				onBlur={() => setShowTooltip(false)}
			>
				<Icon
					size="sm"
					name="info"
					color="subtle-dark"
					aria-label={undefined}
					aria-hidden={true}
				/>
				<TextBody size="xs" asTyped color="subtle-dark">
					Local average
				</TextBody>
			</button>
			{showTooltip && (
				<Tooltip
					arrowPosition="top"
					arrowOffset={90}
					className={classNames(Styles.localAverageTooltip, {
						[Styles.localAverageTooltipEditEstimateForm]:
							variant === 'editEstimateForm',
					})}
					header="Average price"
				>
					The venue offers this service but didn’t provide pricing for it. This
					reflects the average price for the venue’s local market.
				</Tooltip>
			)}
		</TooltipContainer>
	);
};
